import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';

export default function SponsorTicker({ placement }) {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    if (!placement) {
      setSponsors([]);
      return;
    }
    api.getSponsors(placement).then(setSponsors).catch(() => setSponsors([]));
  }, [placement]);

  if (!placement || sponsors.length === 0) return null;

  // Duplicate the list so the scroll loop looks continuous
  const items = [...sponsors, ...sponsors];

  return (
    <div style={styles.wrap}>
      <div style={styles.track}>
        {items.map((s, i) => (
          <span key={`${s.id}-${i}`} style={styles.item}>
            <span style={styles.badge}>Sponsored</span>
            {s.logo_url && (
              <img src={s.logo_url} alt="" style={styles.logoImg} onError={(e) => { e.target.style.display = 'none'; }} />
            )}
            {s.name}
            {s.tagline && <span style={styles.tagline}> — {s.tagline}</span>}
          </span>
        ))}
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    overflow: 'hidden',
    background: '#0a0f1e',
    borderBottom: '1px solid #1e2a3a',
    padding: '6px 0',
  },
  track: {
    display: 'flex',
    gap: '3rem',
    whiteSpace: 'nowrap',
    animation: 'ticker-scroll 25s linear infinite',
    width: 'max-content',
  },
  item: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.4rem',
    color: '#6b7280',
    fontSize: '0.7rem',
    fontFamily: "'Syne', sans-serif",
  },
  badge: {
    fontSize: '0.55rem',
    fontWeight: '700',
    color: '#4b5563',
    border: '1px solid #1e2a3a',
    borderRadius: '3px',
    padding: '1px 4px',
    textTransform: 'uppercase',
  },
  logoImg: {
    width: '16px',
    height: '16px',
    objectFit: 'contain',
    background: '#fff',
    borderRadius: '3px',
    padding: '1px',
  },
  tagline: { color: '#374151' },
};
